import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hide-crisp-client',
  templateUrl: './hide-crisp-client.component.html',
  styleUrls: ['./hide-crisp-client.component.scss']
})
export class HideCrispClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
